<div [formGroup]="orderForm">

  <button (click)="showValues()">Ver valores blocos</button>
  <button (click)="addParameter()">Adicionar Bloco</button>


  <mat-card>
    <div formArrayName="items" *ngFor="let item of _items.controls; let i = index;">
      <div [formGroupName]="i">

        <mat-form-field>
          <input matInput formControlName="x" placeholder="x" type="number">
        </mat-form-field>
        <mat-form-field>
          <input matInput formControlName="y" placeholder="y" type="number">
        </mat-form-field>
        <mat-form-field>
          <input matInput formControlName="Col" placeholder="Col" type="number">
        </mat-form-field>
        <mat-form-field>
          <input matInput formControlName="Row" placeholder="Row" type="number">
        </mat-form-field>
        <mat-form-field>
          <input matInput formControlName="ColsLength" placeholder="ColsLength" type="number">
        </mat-form-field>
        <mat-form-field>
          <input matInput formControlName="RowsLength" placeholder="RowsLength" type="number">
        </mat-form-field>


      </div>

    </div>
  </mat-card>

</div>